import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";
import {Form} from "react-router-dom";
import axios from "axios";

class ManageGameRelease extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            androidFileUrl: null,
            iosFileUrl: null,
            windowsFileUrl: null,
            linuxFileUrl: null,
            macFileUrl: null,
            androidFileUploadProgress: 0
        };
    }

    componentDidMount() {
        this.hideOrShowFilesForm(false);

        var progressBar = document.getElementById("android_file_upload_progress");
        progressBar.style.visibility = 'hidden';
    }

    handleSubmit(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {
            'version': e.target.version.value,
            //'release_date': e.target.release_date.value
        };

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/release', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then((response) => {
            console.log(response);
            console.log(JSON.stringify(body));

            this.hideOrShowFilesForm(true);
            //window.location.reload(false);
        });
    }

    ProgressHandler(e){
        var percent = (e.loaded / e.total) * 100;

        //console.log(percent);

        this.setState({
            androidFileUploadProgress: Math.round(percent)
        })

        //var progressBar = document.getElementById("android_file_upload_progress");
        //progressBar.value = percent;
    };

    SuccessHandler(e){
        //statusRef.current.innerHTML = e.target.responseText;
    };

    ErrorHandler(){
        //statusRef.current.innerHTML = "upload failed!!";
    };

    AbortHandler(){
        //statusRef.current.innerHTML = "upload aborted!!";
    };

    async handleSubmitFilesUpload(e) {
        e.preventDefault();

        var progressBar = document.getElementById("android_file_upload_progress");
        progressBar.style.visibility = 'visible';

        const { navigate } = this.props;

        const {androidFileUrl, iosFileUrl, windowsFileUrl, linuxFileUrl, macFileUrl} = this.state;
        console.log(androidFileUrl);

        const formData = new FormData();

        if (androidFileUrl !== null) formData.append("android_file_url", androidFileUrl);
        if (iosFileUrl !== null) formData.append("ios_file_url", iosFileUrl);
        if (windowsFileUrl !== null) formData.append("windows_file_url", windowsFileUrl);
        if (macFileUrl !== null) formData.append("mac_file_url", macFileUrl);
        if (linuxFileUrl !== null) formData.append("linux_file_url", linuxFileUrl);

        console.log(formData);

        /*this.setState({
            loading: true
        });*/

        let target = format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/release/files', this.props.game.id.toString());

        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", this.ProgressHandler.bind(this), false);
        xhr.addEventListener("load", this.SuccessHandler.bind(this), false);
        xhr.addEventListener("error", this.ErrorHandler.bind(this), false);
        xhr.addEventListener("abort", this.AbortHandler.bind(this), false);
        xhr.open("POST", target);
        xhr.send(formData);

        const resp = await axios.post(target, formData, {
            headers: {
                "content-type": "multipart/form-data",
                "Authorization": `Bearer ${sessionStorage.getItem('token')}`,
            },
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
        });

        progressBar.style.visibility = 'hidden';

        window.location.reload(false);
    }

    hideOrShowFilesForm(show){
        let form = document.getElementById('files');

        if (show) {
            form.style.visibility = 'visible';
        } else {
            form.style.visibility = 'hidden';
        }
    }

    render() {
        if(this.state.loading) {
            return <h2>Loading...</h2>
        }
        else {
                return <div>
                    <h3>Number of releases - {this.props.last_release ? this.props.last_release.id : 0}</h3>
                    <a href='#'>Releases library</a>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <label>Version: </label>
                        <input class="form-control" type="text" name="version" defaultValue={this.props.last_release ? this.props.last_release.version : ''}/>
                        <br/>
                        {/*<label>Release date: </label>
                        <input class="form-control" type="text" name="release_date" defaultValue={this.props.last_release ? this.props.last_release.release_date.toString() : ''}/>
                        <br/>*/}

                        <input class="btn btn-warning" type="submit" value="Process"/>
                    </form>
                    <h3>Current files: </h3>
                    <ul className="list-group">
                        <li className="list-group-item">Android: {this.props.last_release ? (
                                this.props.last_release.android_file_url ? this.props.last_release.android_file_url : 'unavailable'
                            )
                            : 'Unavailable'}
                        </li>
                        <li className="list-group-item">IOS: {this.props.last_release ? (
                            this.props.last_release.ios_file_url ? this.props.last_release.ios_file_url : 'unavailable'
                        ) : 'Unavailable'}
                        </li>
                        <li className="list-group-item">Win: {this.props.last_release ? (
                            this.props.last_release.windows_file_url ? this.props.last_release.windows_file_url : 'unavailable'
                        ) : 'Unavailable'}
                        </li>
                        <li className="list-group-item">Mac: {this.props.last_release ? (
                            this.props.last_release.mac_file_url ? this.props.last_release.mac_file_url : 'unavailable'
                        ) : 'Unavailable'}
                        </li>
                        <li className="list-group-item">Other: {this.props.last_release ? (
                            this.props.last_release.linux_file_url ? this.props.last_release.linux_file_url : 'unavailable'
                        ) : 'Unavailable'}</li>
                    </ul>

                    <form id="files" onSubmit={this.handleSubmitFilesUpload.bind(this)}>
                        <div id="android_file_upload_progress">
                            Processing file: {this.state.androidFileUploadProgress}%
                            <br/><progress value={this.state.androidFileUploadProgress} max="100" />
                        </div>

                        <label>Android file: </label>
                        <br/>
                        <input class="form-control-file" type="file" name="android_file_url" onChange={
                            (e) => this.setState({
                                androidFileUrl:e.target.files[0],
                            })
                        }/>
                        <br/>
                        <label>IOS file: </label>
                        <br/>
                        <input class="form-control-file" type="file" name="ios_file_url" onChange={
                            (e) => this.setState({
                                iosFileUrl:e.target.files[0],
                            })
                        }/>
                        <br/>
                        <label>Windows file: </label>
                        <br/>
                        <input className="form-control-file" type="file" name="windows_file_url" onChange={
                            (e) => this.setState({
                                windowsFileUrl: e.target.files[0],
                            })
                        }/>
                        <br/>
                        <label>Mac file: </label>
                        <br/>
                        <input className="form-control-file" type="file" name="mac_file_url" onChange={
                            (e) => this.setState({
                                macFileUrl: e.target.files[0],
                            })
                        }/>
                        <br/>
                        <label>Others os file: </label>
                        <br/>
                        <input class="form-control-file" type="file" name="linux_file_url" onChange={
                            (e) => this.setState({
                                linuxFileUrl:e.target.files[0],
                            })
                        }/>
                        <br/>
                        <br/>

                        <input class="btn btn-success" type="submit" value="Save"/>
                    </form>
                </div>
        }
    }
}

export default withRouter(ManageGameRelease);
